<template>
	<span class="footprint-icon" aria-hidden="true"></span>
</template>

<script>
// Het Systeemlogboek-icoon uit Figma (`footprint`, node 7062:6403). Mdi 5.9.55
// heeft het niet, dus het SVG-bestand zelf dient als masker: zo kleurt het mee
// met currentColor, roze als het menu-item actief is.
export default { name: "FootprintIcon" };
</script>

<style>
.footprint-icon {
	display: inline-block;
	width: 1em;
	height: 1em;
	background-color: currentColor;
	-webkit-mask: url("~@/assets/icons/footprint.svg") center / contain no-repeat;
	mask: url("~@/assets/icons/footprint.svg") center / contain no-repeat;
}
</style>
